/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';

export default class extends UiBookingPriceTablesBaseComponent {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::GuestPrice': typeof UiBookingPriceTablesBaseComponent;
  }
}
